export const isEmailAddressValid = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email) {
    return undefined;
  }
  return emailRegex.test(email);
};

export const TERMINATION_REASON_CODE = 'LAST_DAY_PAY';

// "Termination", "termination", "LAST_DAY_PAY" and "last day pay" all compare equal
const normaliseReason = value =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');

const findReason = (reasons, value) => {
  const needle = normaliseReason(value);
  if (!needle) {
    return undefined;
  }
  return (reasons || []).find(
    reason => normaliseReason(reason.name) === needle || normaliseReason(reason.display_value) === needle,
  );
};

export const getReasonLabel = (reasons, value) => findReason(reasons, value)?.display_value ?? value;

// Uploaded files must use the label ("Termination"), never the code ("LAST_DAY_PAY")
export const matchReasonLabel = (reasons, value) => {
  const needle = String(value ?? '')
    .trim()
    .toLowerCase();
  return (reasons || []).find(reason => reason.display_value.toLowerCase() === needle)?.display_value;
};

export const getReasonCode = (reasons, value) => findReason(reasons, value)?.name ?? value;

export const isTerminationReason = (reasons, value) => getReasonCode(reasons, value) === TERMINATION_REASON_CODE;
